import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {entities as entitiesAction} from 'actions'
import useUserLoginStatus from './useUserLoginStatus'
import useOpenFutureStatus from './useOpenFutureStatus'

export default function useAdlProvider () {
  const dispatch = useDispatch()
  const isLogin = useUserLoginStatus()
  const ifOpenFuture = useOpenFutureStatus()
  const fetchData = useCallback(async () => {
    const res = await ApiSdk.futures.getAdlQueueData()
    dispatch(entitiesAction({adl: res}))
  }, [dispatch])

  useEffect(() => {
    if (isLogin && ifOpenFuture) {
      fetchData()
    }
  }, [dispatch, fetchData, isLogin, ifOpenFuture])
}
